import useSWR from 'swr'

import { FetchError } from '../fetchError'
import { FetchResponse } from '../fetchResponse'
import { FetchResult } from '../fetchResult'
import { getWithBaseUrlAndToken } from '../fetchWithBaseUrlAndToken'
import { TenantDto } from './model'

export function useAllTenants(): FetchResult<TenantDto[]> {
  const { data, error, mutate, isLoading } = useSWR<FetchResponse<TenantDto[]>, FetchError>(
    '/tenants',
    getWithBaseUrlAndToken,
  )

  return {
    data: data?.body,
    isLoading,
    error,
    mutate,
    etag: data?.etag,
  }
}

export function useTenantById(tenantId: string): FetchResult<TenantDto> {
  const { data, error, mutate, isLoading } = useSWR<FetchResponse<TenantDto>, FetchError>(
    `/tenants/${tenantId}`,
    getWithBaseUrlAndToken,
  )

  return {
    data: data?.body,
    isLoading,
    error,
    mutate,
    etag: data?.etag,
  }
}
